export const headerData = {
  title: 'Jason Toups',
  author: 'Jason Toups',
  contact: [
    {
      display: 'me@jasontoups.com',
      link: 'mailto:me@jasontoups.com',
    },
    {
      display: 'LinkedIn',
      link: 'https://www.linkedin.com/in/jasontoups/',
    },
    {
      display: 'Portfolio',
      link: 'https://jasontoups.github.io/',
    },
    {
      display: 'Github',
      link: 'https://github.com/JasonToups',
    },
    {
      display: '404.625.6530',
      link: 'tel:4046256530',
    },
  ],
  experience:
    'Frontend Engineer, with over 15 years of Software Production experience, including Engineering, Testing & UI/UX Design',
};

export const technicalSkillsData = [
  {
    skillType: 'Programming',
    skillList: [
      'Typescript',
      'Tailwind',
      'React',
      'Python',
      'CrewAI',
      'Docker',
      'Markdown',
      'NodeJS',
      'Angular',
      'Vue',
      'RxJS',
      'Shell',
      'HTML',
      'CSS',
      'JQuery',
    ],
  },
  {
    skillType: 'Production',
    skillList: [
      'Git',
      'GitHub Actions',
      'Software Releases',
      'JIRA',
      'UI/UX Design',
      'Figma',
      'Affinity Designer',
      'Adobe Creative Suite',
      'Technical Documentation',
      'Agile Development/Scrum Master',
      'A/B Testing',
    ],
  },
];

export const workExperienceData = [
  {
    company: 'Dfinity',
    title: 'Sr. Front End Engineer',
    duration: {
      start: {
        month: 'Oct',
        year: '2024',
      },
      end: {
        month: 'Jul',
        year: '2025',
        present: false,
      },
    },
    location: 'San Francisco',
    remote: true,
    description:
      'DFINITY Foundation develops the Internet Computer, a decentralized cloud platform. Contributed to the launch of Caffeine AI, an AI-powered application platform enabling users to build applications through natural language workflows. Worked with NextJS, Typescript, and Tailwind on the Caffeine AI Team.',
    jobTasks: [
      'Played a key role in the public demo and launch of Caffeine, building production-grade applications from design through deployment.',
      'Led platform-wide UI/UX Design System standardization across the App Marketplace and Core App, improving consistency and accessibility.',
      'Engineered scalable React/TypeScript architecture with mobile-first and responsive design principles.',
      'Developed 130 frontend templates used as structured training data for AI-assisted site generation.',
      'Built AI workflows in Python using CrewAI and MCP servers to generate technical documentation and structured application templates.',
      'Engineered a chat interface for interacting with Large Language Models.',
      'Strengthened authentication flows and improved user experience across core platform surfaces.',
    ],
    technologies: [
      'TypeScript',
      'NextJS',
      'React',
      'Tailwind',
      'Design Systems',
      'Python',
      'CrewAI',
      'MCP Servers',
      'Accessibility',
      'Technical Documentation',
    ],
  },
  {
    company: 'Bill',
    title: 'Sr. Front End Engineer',
    duration: {
      start: {
        month: 'Jul',
        year: '2022',
      },
      end: {
        month: 'Dec',
        year: '2023',
        present: false,
      },
    },
    location: 'San Jose',
    remote: true,
    description:
      'Worked with Angular & RxJS on the revenue-generating International Payments Team.',
    jobTasks: [
      'Retrofitted existing Domestic payment flows with International options, to enable users to make International Payments with current exchange rates, increasing revenue by 15%.',
      'Operated across several teams to enable these features by working with the code owners to develop features and fix bugs.',
      'Wrote package.json scripts to streamline repetitive engineering tasks.',
      'Created training documentation in Markdown, on Confluence to onboard new engineers and standardize processes.',
    ],
    technologies: [
      'TypeScript',
      'Angular',
      'RxJS',
      'Technical Documentation',
      'Training',
      'JavaScript',
    ],
  },
  {
    company: 'Williams Sonoma Inc',
    title: 'Front End Engineer',
    duration: {
      start: {
        month: 'Apr',
        year: '2021',
      },
      end: {
        month: 'June',
        year: '2022',
        present: false,
      },
    },
    location: 'San Francisco',
    remote: true,
    description:
      'Worked on the Micro Front End team, transitioning Production pages from 6 brands, into a unified Vue project.',
    jobTasks: [
      'Engineered styling & architectural updates to Vue components to all 6 supported brands, including; the Product Information pages for the Purchasing Component & Product Flags Component, Shop pages, & Content pages.',
      'Solved Local Environment Stability Issues with a self-directed NodeJS project that automated engineering tasks, including; cloning 11 repos for multiple remotes per brand. This reduced the first-time setup for local development from about 1 week to 1/2 a day.',
      'Automated feature branch creation for our 4 repos with my script that created multiple feature branches with the JIRA ticket number, and updated local branches to the latest release code.',
      'Managed & Migrated pull requests from team-specific repos, to Bedrock & Release Management repos, including batch cherry-picked commits from my team to the upstream repos. I was responsible for making sure all of the features for the release were included in the release branches.',
      'Mentored junior engineers on my team with paired programming sessions and sharing my documentation.',
    ],
    technologies: [
      'Javascript',
      'Vue',
      'SASS',
      'NodeJS',
      'Shell',
      'Markdown',
      'Adobe Experience Manager',
    ],
  },
  {
    company: 'NewlyWords',
    title: 'Front End Engineer',
    duration: {
      start: {
        month: 'Oct',
        year: '2020',
      },
      end: {
        month: 'Apr',
        year: '2021',
        present: false,
      },
    },
    location: 'San Francisco',
    remote: true,
    description:
      'NewlyWords is a React & Ruby memory book platform where hundreds of users per day can invite their friends & family to collaborate on a commemorative digital or physical book.',
    jobTasks: [
      'Engineered the Memory Book Project Dashboard in React with custom Hooks, where project owners view and edit pages submitted from their contributors, and view information about their book.',
      'Built the Questionnaire as a new memory book content type, providing project owners a place to ask their contributors questions to answer for their collaborative memory book content.',
      'Developed a design guide with classNameNames and partials, from the product design system, to build stylesheets which implemented reusable classNames and styles, reducing lines of code by 25%.',
      'Mentored a junior UI/UX designer by providing design advice, Figma help, and to think about user experience from our user’s perspective.',
    ],
    technologies: ['Javascript', 'React', 'React-Hooks', 'Ruby', 'Shell', 'Markdown'],
  },
  {
    company: 'Hawaii United Okinawa Association',
    title: 'Front End Engineer',
    duration: {
      start: {
        month: 'Apr',
        year: '2020',
      },
      end: {
        month: 'Oct',
        year: '2020',
        present: false,
      },
    },
    location: 'San Francisco',
    remote: true,
    description:
      'HUOA is a philanthropic organization dedicated to cultural exchange between Hawaii & Japan.',
    jobTasks: [
      'Refactored existing static HUOA site to a dynamic React site, using Wordpress on the backend.',
      'Built reusable containers & components that were used across the site.',
      'Engineered custom Hooks to handle State between multiple components.',
    ],
    technologies: [
      'Javascript',
      'React',
      'React-Hooks',
      'Sass',
      'Technical Documentation',
      'Training',
    ],
  },
  {
    company: 'LifeStreet',
    title: 'Sr. Product Designer',
    duration: {
      start: {
        month: 'Sept',
        year: '2017',
      },
      end: {
        month: 'Oct',
        year: '2019',
        present: false,
      },
    },
    location: 'San Francisco',
    remote: false,
    description:
      'Engineered & Designed mobile marketing materials for  the programmatic marketing platform.',
    jobTasks: [
      'Engineered HTML playable ads in Javascript, with Adobe Animate for clients.',
      'Implemented Responsive Design solution that consistently generated increased ad engagement by 30% across all existing playable ads, and became an engineering standard.',
      'Created Playable Ad Production Workflow, to design mockups and storyboards for ad approval, and CSS for engineers.',
      'Upgraded client assets with self-designed elements, that were approved by advertisers including Disney, Warner Brothers & King, for their Frozen, Harry Potter, and Candy Crush IPs.',
    ],
    technologies: [
      'Javascript',
      'Figma',
      'UI/UX',
      'User Interface Design',
      'Technical Documentation',
      'Training',
    ],
  },
  {
    company: 'Chartboost',
    title: 'Product Designer',
    duration: {
      start: {
        month: 'Feb',
        year: '2017',
      },
      end: {
        month: 'Aug',
        year: '2017',
        present: false,
      },
    },
    location: 'San Francisco',
    remote: false,
    description:
      'Produced playable ads, while coordinating the production in JIRA, spanning three global regions, four outsourced development studios, and a team of internal engineers.',
    jobTasks: [
      'Designed UI/UX storyboards for free-to-play playable ads in Figma, to send to advertisers for approval and engineering to build the ads.',
      'Scaled the production of playables 170% in the first 2 months.',
      'Iterated existing ads with A/B testing, tracked and reported results from Metamarkets data to all stakeholders.',
    ],
    technologies: [
      'Figma',
      'UI/UX',
      'User Interface Design',
      'Product Development',
      'Technical Documentation',
      'Training',
    ],
  },
  {
    company: 'Chartboost',
    title: 'Sr. Quality Engineering Lead',
    duration: {
      start: {
        month: 'May',
        year: '2015',
      },
      end: {
        month: 'Jan',
        year: '2017',
        present: false,
      },
    },
    location: 'San Francisco',
    remote: false,
    description: 'Tested Chartboost SDKs for iOS, Android & Unity for release.',
    jobTasks: [
      'Wrote automation test scripts in Python, using PyTest and Selenium with the Appium framework.',
      'Ran & Maintained build scripts to create release builds, with Jenkins.',
      'Tested the features going into the SDK, using Charles Proxy testing to inject responses from the server to the SDK.',
    ],
    technologies: [
      'Python',
      'PyTest',
      'Selenium',
      'Appium',
      'Team Leadership',
      'Technical Documentation',
      'Training',
    ],
  },
  {
    company: 'Kixeye',
    title: 'Mobile Quality Engineering Lead',
    duration: {
      start: {
        month: 'Feb',
        year: '2013',
      },
      end: {
        month: 'Jan',
        year: '2015',
        present: false,
      },
    },
    location: 'San Francisco',
    remote: false,
    description:
      'Prepared two mobile free-to-play games for App Store submission, from tentpole Kixeye IP, and contributed several level designs for War Commander Mobile in Unity.',
    jobTasks: [
      'Wrote automation test scripts in Python, using PyTest and Selenium with the Appium framework.',
      'Prepared release builds by running build scripts, and uploading builds to TestFlight.',
      'Managed testing responsibilities for internal and external testing teams.',
      'Standardized Feature Progress Reporting and Feature Progress JIRA dashboards across the Quality team.',
    ],
    technologies: [
      'Javascript',
      'MonkeyTalk',
      'Release Management',
      'Team Leadership',
      'Technical Documentation',
      'Training',
    ],
  },
];

export const educationData = {
  school: 'University of New Orleans',
  degreeType: 'BA',
  department: 'Philosophy',
};

const resumeData = {
  headerData,
  workExperienceData,
  technicalSkillsData,
  educationData,
};

export default resumeData;
